export const keys = [
  "auth",
]

export const clearStorage = () => {
  keys.forEach(key => {
    localStorage.removeItem(key);
  })
}

export const setStorage = (data) => {
  keys.forEach(key => {
    data[key] && localStorage.setItem(key, data[key]);
  })
}

export const IS_DEV = process.env.NODE_ENV === "development";